<template>
  <div class="data-migration-task-list">
    <action-bar>
      <btn-style :btn-list="btnList" class="btn-box"></btn-style>
    </action-bar>
    <common-bg-plate>
      <normal-table
        ref="commonTable"
        :table-col="tableCol"
        :table-data="list"
        :operator="operator"
        :show-edit="showEdit"
        :paging="paging"
        @pagination="handleSizeOrPageChange"
      >
        <template slot="status" slot-scope="{ param }">
          <span class="task-status" :class="param.row.status | transStatusClass">{{
            param.row.status | transStatus()
          }}</span>
        </template>
      </normal-table>
    </common-bg-plate>
    <task-details-info ref="detailsInfo"></task-details-info>
    <set-server-config
      ref="setConfig"
      @serviceAddressChanged="onServiceAddressChanged"
      @update:list="getList"
    ></set-server-config>
    <add-data-migration
      ref="addDataMigration"
      @update:list="getList(paging.limit, paging.offset)"
    ></add-data-migration>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import taskDetailsInfo from './components/taskDetailsInfo'
import setServerConfig from './components/setServerConfig'
import addDataMigration from './components/addDataMigration'

export default {
  name: 'MigrationTaskList',
  components: {
    taskDetailsInfo,
    setServerConfig,
    addDataMigration
  },
  filters: {
    transStatus: function(value) {
      if (value == 1) {
        return '待迁移'
      } else if (value == 2) {
        return '迁移中'
      } else if (value == 3) {
        return '迁移成功'
      } else if (value == 4) {
        return '迁移暂停'
      } else {
        return '错误'
      }
    },
    transStatusClass: function(value) {
      if (value == 1) {
        return 'is-wating'
      } else if (value == 2) {
        return 'is-running'
      } else if (value == 3) {
        return 'is-success'
      } else if (value == 4) {
        return 'is-paused'
      } else {
        return 'is-failed'
      }
    }
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '新建数据迁移',
          click: () => {
            return this.addMigrationTask()
          }
        }
      ],
      // 设置table的列
      tableCol: [
        { prop: 'task_id', label: '任务ID' },
        { prop: 'task_name', label: '任务名称' },
        { prop: 'origin_chain_type', label: '原链类型' },
        { prop: 'target_chain_type', label: '目标链' },
        {
          prop: 'status',
          label: '状态',
          slotName: 'status'
        },
        {
          prop: 'create_time',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row.create_time)
          }
        }
      ],
      list: [],
      // table的基本操作
      operator: [
        {
          text: '查看详情',
          click: (row, col, cellValue) => {
            this.checkDetail(row)
          },
          icon: 'icon-check',
          showText: false,
          class: 'operate-check'
        },
        {
          text: '修改',
          click: (row, col, cellValue) => {
            this.edit(row)
          },
          icon: 'icon-apply',
          showText: false,
          class: 'operate-edit',
          formatter: row => {
            return row.status != 2
          }
        },
        {
          text: '执行迁移',
          click: (row, col, cellValue) => {
            this.handleStart(row)
          },
          icon: 'icon-migration',
          showText: false,
          class: 'operate-migration',
          formatter: row => {
            return row.status == 1
          }
        },
        {
          text: '停止迁移',
          click: (row, col, cellValue) => {
            this.handleStop(row)
          },
          icon: 'icon-cancel',
          showText: false,
          class: 'operate-cancel',
          formatter: row => {
            return row.status == 2
          }
        },
        {
          text: '重启迁移',
          click: (row, col, cellValue) => {
            this.handleRestart(row)
          },
          icon: 'icon-refresh',
          showText: false,
          class: 'operate-refresh'
        }
      ],
      paging: {
        total: 0,
        limit: 10,
        offset: 0
      },
      // 是否显示操作标头
      showEdit: true,
      serviceAddress: ''
    }
  },
  computed: {
    ...mapState({})
  },
  mounted() {
    if (!this.$route.query.serviceAddress) {
      this.$refs.setConfig.handleOpen(this.serviceAddress)
    } else {
      this.serviceAddress = `http://${this.$route.query.serviceAddress}`;
      this.getList()
    }
  },
  methods: {
    getList(page_limit = 10, page_num = 0) {
      let params = {
        page_limit,
        page_num,
        task_status: -1
      }

      let url = `${this.serviceAddress}/transfer/tasks/query`
      let self = this
      this.$apis.datamigration.queryTask(url, params).then(res => {
        if (res.code == 200) {
          self.list = res.result.tasks
          self.paging.total = res.result.task_total
          self.paging.limit = res.result.page_index
          self.paging.offset = res.result.page_num
        } else {
          self.$message.error(res.msg)
        }
        return
      })
    },

    addMigrationTask() {
      this.$refs.addDataMigration.handleOpen(this.serviceAddress)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset + 1)
    },
    formatTime(time) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', time)
    },

    checkDetail(row) {
      this.$refs.detailsInfo.handleOpen(row, this.serviceAddress)
    },
    edit(row) {
      this.$refs.addDataMigration.handleOpen(this.serviceAddress, row, true)
    },
    handleStart(row) {
      let url = `${this.serviceAddress}/transfer/start_task/${row.task_id}`
      this.$apis.datamigration.handleStart(url, {}).then(res => {
        if (res.code == 200) {
          this.$message.success('迁移成功...')
          this.getList(this.paging.limit, this.paging.offset)
        } else {
          this.$message.error(res.msg)
        }
        return
      })
    },
    //重启
    handleRestart(row) {
      let url = `${this.serviceAddress}/transfer/restart_task/${row.task_id}`
      this.$apis.datamigration.handleRestart(url, {}).then(res => {
        if (res.code == 200) {
          this.$message.success('重启成功...')
          this.getList(this.paging.limit, this.paging.offset)
        } else {
          this.$message.error(res.msg)
        }
        return
      })
    },
    //停止
    handleStop(row) {
      let url = `${this.serviceAddress}/transfer/stop_task/${row.task_id}`
      this.$apis.datamigration.handleStopApi(url, {}).then(res => {
        if (res.code == 200) {
          this.$message.success('停止成功...')
          this.getList(this.paging.limit, this.paging.offset)
        } else {
          this.$message.error(res.msg)
        }
        return
      })
    },
    onServiceAddressChanged(serviceUrl) {
      console.log('onServiceAddressChanged', serviceUrl)
      this.serviceAddress = `http://${serviceUrl}`
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'data-migration-task-list',
  (
    --data-migration-task-list-operate-check-color: #45c2ff,
    --data-migration-task-list-operate-edit-color: #55da62,
    --data-migration-task-list-operate-cancel-color: #e95757,
    --data-migration-task-list-operate-migration-color: #fac20a,
    --data-migration-task-list-operate-refresh-color: #55da62,
    --data-migration-task-list-status-wating-color: #45c2ff,
    --data-migration-task-list-status-running-color: #fac20a,
    --data-migration-task-list-status-success-color: #55da62,
    --data-migration-task-list-status-paused-color: #45c2ff,
    --data-migration-task-list-status-failed-color: #e95757
  ),
  (
    --data-migration-task-list-operate-check-color: #45c2ff,
    --data-migration-task-list-operate-edit-color: #55da62,
    --data-migration-task-list-operate-cancel-color: #e95757,
    --data-migration-task-list-operate-migration-color: #fac20a,
    --data-migration-task-list-operate-refresh-color: #55da62,
    --data-migration-task-list-status-wating-color: #45c2ff,
    --data-migration-task-list-status-running-color: #fac20a,
    --data-migration-task-list-status-success-color: #55da62,
    --data-migration-task-list-status-paused-color: #45c2ff,
    --data-migration-task-list-status-failed-color: #e95757
  )
);
.data-migration-task-list {
  @include adaptation(
    (
      --data-migration-task-list-status-padding: 2px 8px
    )
  );
  --data-migration-task-list-min-height: var(
    --base-main-router-body-avaliable-height-with-action-bar
  );
  .normal-table-wrap {
    height: 100%;
    min-height: var(--data-migration-task-list-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--data-migration-task-list-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--data-migration-task-list-min-height);

        .task-status {
          padding: var(--data-migration-task-list-status-padding);
          display: inline-block;

          &.is-success {
            color: var(--data-migration-task-list-status-success-color);
          }
          &.is-wating {
            color: var(--data-migration-task-list-status-wating-color);
          }

          &.is-running {
            color: var(--data-migration-task-list-status-running-color);
          }

          &.is-paused {
            color: var(--data-migration-task-list-status-paused-color);
          }

          &.is-failed {
            color: var(--data-migration-task-list-status-failed-color);
          }
        }

        .operate-item {
          &.operate-check {
            color: var(--data-migration-task-list-operate-check-color);
          }

          &.operate-edit {
            color: var(--data-migration-task-list-operate-edit-color);
          }

          &.operate-migration {
            color: var(--data-migration-task-list-operate-migration-color);
          }

          &.operate-cancel {
            color: var(--data-migration-task-list-operate-cancel-color);
          }

          &.operate-refresh {
            color: var(--data-migration-task-list-operate-refresh-color);
          }
        }
      }
    }
  }
}
</style>
